import baseApi from '@store/api/baseApi';

export const targetApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getCRMTargetList: builder.query({
			query: (params) => ({
				url: 'target/all',
				params
			}),
			providesTags: ['Target']
		}),
		getTargetBreakdown: builder.query({
			query: (params) => ({
				url: `target/breakdowns/${params}`
			}),
			providesTags: ['Breakdowns']
		}),
		getTargetById: builder.query({
			query: (params) => ({
				url: `target/${params}`
			})
		}),
		addTargetBreakdown: builder.mutation({
			query: (requestBody) => ({
				url: `target/add-breakdown`,
				method: 'POST',
				body: requestBody
			}),
			invalidatesTags: ['Breakdowns']
		}),
		updateTargetBreakdown: builder.mutation({
			query: (queryParams) => ({
				url: `target/breakdown/${queryParams.params}`,
				method: 'PUT',
				body: queryParams.requestBody
			}),
			invalidatesTags: ['Breakdowns']
		}),
		setTarget: builder.mutation({
			query: (requestBody) => ({
				url: `target/add`,
				method: 'POST',
				body: requestBody
			}),
			invalidatesTags: ['Target']
		}),
		updateTarget: builder.mutation({
			query: (queryParams) => ({
				url: `target/${queryParams.params}`,
				method: 'PUT',
				body: queryParams.requestBody
			}),
			invalidatesTags: ['Target']
		}),
		finalizeTarget: builder.mutation({
			query: (params) => ({
				url: `target/finalize/${params}`,
				method: 'POST'
			}),
			invalidatesTags: ['Target']
		})
	})
});

export const {
	useGetCRMTargetListQuery,
	useGetTargetBreakdownQuery,
	useAddTargetBreakdownMutation,
	useUpdateTargetBreakdownMutation,
	useGetTargetByIdQuery,
	useSetTargetMutation,
	useUpdateTargetMutation,
	useFinalizeTargetMutation
} = targetApi;
